<template>
  <el-row ref="mainArea" class="main-area" type="flex">

    <!-- start Left Sidebar -->
    <el-col class="left-sidebar" :class="isCollapsed && 'collapsed'">

      <div v-if="!isMobile" class="left-sidebar--logo">
        <img :class="isCollapsed && 'display-none'" src="assets/logo.svg" alt="WorkoutAP Logo">
        <img :class="!isCollapsed && 'display-none'" src="assets/emblem.svg" alt="WorkoutAP Logo">
      </div>

      <div class="left-sidebar--inputs" :class="isCollapsed && 'display-none'">
        <label>workout room</label>
        <el-popover
          placement="right"
          width="205"
          trigger="manual"
          content="Minimum of 3 characters. Letters and numbers only."
          :value='!isMobile ? channelNameTooltip : false'
          class="channel-name-tooltip"
        >
          <input
            slot="reference"
            ref="channelName"
            type="text"
            v-model='option.channel'
            :placeholder='isTrainer ? "Start, Schedule, or Join a room" : "Start or Join a room"'
            :disabled='joined'
            @input="option.channel = option.channel.replace(/[^A-Za-z0-9 ]/g, '')"
            @keyup.enter='joinRoom'
            @focus="toggleHiddenActions"
            @blur="toggleHiddenActions"
          />
        </el-popover>
      </div>

      <div class="left-sidebar--actions" :class="[isCollapsed && 'display-none', (isHidden && this.option.channel == '' && !isMobile) && 'invisible-actions']">
        <el-button :style="!isTrainer && 'width: 100%;'" class="left-sidebar--action-btns" type="primary" round @click='joinRoom' v-if='!joined' :disabled='startDisabled'>Start</el-button>
        
        <!-- start Schedule popover -->
        <el-popover id="schedulePopover" trigger="manual" class="left-sidebar--action-btns" v-if='!joined && isTrainer' placement="right-start" width="300" v-model="scheduleVisible">
          <el-button slot="reference" round icon="el-icon-time" @click="scheduleVisible = !scheduleVisible" :disabled='startDisabled'>Schedule</el-button>
          <h3 style="margin-top: 0">Schedule a workout</h3>
          
          <label>workout room</label>
          <input type="text" v-model='option.channel'>
          <label>workout</label>
          <el-cascader
            style="width: 100%"
            placeholder="Pick a workout"
            id="selectScheduledWO"
            v-model="scheduledWOKey"
            :options="woData"
            filterable
            clearable
          />
          <label>start time</label>
          <el-date-picker type="datetime" placeholder="Select date and time" default-time="12:00:00" format="MM/dd/yyyy h:mm A" value-format="timestamp" v-model="startTime"/>
          <label>duration <span class="description">in minutes</span></label>
          <el-input-number placeholder="Duration in minutes" :min="5" :step="5" controls-position="right" v-model="duration"/>
          <label>price <span class="description">per attendee</span></label>
          <div class="price">
            <el-input-number placeholder="14.50" :precision="2" :step="0.10" :min="1" controls-position="right" v-model="price"/>
          </div>
          <el-tag :key="tag" v-for="tag in scheduledWorkoutTags" closable :disable-transitions="false" @close="handleTagClose(tag)">{{tag}}</el-tag>
          <el-input class="input-new-tag" v-if="inputTagVisible" v-model="inputTagValue" ref="saveTagInput" size="mini" @keypress.enter.native="handleTagInputConfirm" @blur="inputTagVisible = false"/>
          <el-button v-else class="button-new-tag" size="mini" round @click="showTagInput" icon="el-icon-plus">New Tag</el-button>
          <el-radio-group class="share-status" v-model="shareStatus" size="mini">
            <el-tooltip effect="dark" content="Available for discovery and open for anyone to register/join." placement="bottom">
              <el-radio-button label="open">Open</el-radio-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="Invite only. Not available to be discovered. PIN access." placement="bottom">
              <el-radio-button label="private">Private</el-radio-button>
            </el-tooltip>
          </el-radio-group>

          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="cancelConfirmSchedule">Cancel</el-button>
            <el-button :disabled='confirmScheduleDisabled' @click='confirmSchedule' type="primary" round size="mini">Schedule</el-button>
          </div>

        </el-popover>
        <!-- end Schedule popover -->
        
        <el-button class="left-sidebar--action-btns" :type="leaveBtnText == 'Close room' ? 'danger' : 'warning'" round @click='leaveRoom' v-if='joined'>{{ leaveBtnText }}</el-button>
        <el-button class="left-sidebar--action-btns" type="primary" plain round @click='inviteRoom(option.channel)' v-if='joined'>Invite link</el-button>
      </div>

      <hr>
      <div v-if='joined' class="active-users" :class="isCollapsed && 'display-none'">
        <template v-if='roomCreator.username !== username'>
          <label>room host</label>
          <div class="active-users--creator">
            <el-tooltip effect="dark" :content='roomCreator.username' placement="bottom-start">
              <el-avatar shape="square" :size="60" fit="cover" :src="roomCreator.profilePic"></el-avatar>
            </el-tooltip>
          </div>
        </template>

        <template v-if='activeUsers && (roomCreator.username == username)'>
          <label>room attendees</label>
          <div class="active-users--list">
            <el-tooltip v-for="activeUser in activeUsers" :key="activeUser.username" effect="dark" :content='activeUser.username' placement="bottom-start">
              <el-avatar shape="square" :size="60" fit="cover" :src="activeUser.profilePic"></el-avatar>
            </el-tooltip>
          </div>
        </template>
      </div>
      <hr style="margin-bottom: 0;" v-if='joined' :class="isCollapsed && 'display-none'">
      <WorkoutSelector
        v-if='joined'
        :roomName='option.channel'
        :activeWorkout='selectedWorkout'
        :isCollapsed='isCollapsed'
      /> <!-- && (roomCreator.username == username) -->
      <div v-if="!isMobile" class="hide-sidebar">
        <hr style="margin-bottom: 0;">
        <el-button @click="toggleCollapse" class="hide-sidebar--btn" :icon="isCollapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'">{{!isCollapsed ? 'Hide sidebar' : ''}}</el-button>
      </div>
    </el-col>
    <!-- end Left Sidebar -->

    <!-- start Video Area -->
    <el-col class="view">
      <Menu
        @settingsTrigger='toggleSettings'
        @workoutsTrigger='toggleWorkouts'
        @discoTrigger='toggleDiscover'
        @logoutTrigger='leaveRoom'
        :joined='joined'
      />

      <div v-if="!joined" class="title-area">
        <p>Welcome!</p>
        <h1>Discover Workouts{{isTrainer ? ', Schedule a Workout,' : '' }} or Start a New One.</h1>
      </div>

      <div class="video local">
        <StreamPlayer :local="true" :stream="localStream" :domId="localStream.getId()" v-if="localStream"></StreamPlayer>
      </div>
      <div class="video remote" :key="index" v-for="(remoteStream, index) in remoteStreams">
        <StreamPlayer :local="false" :stream="remoteStream" :domId="remoteStream.getId()"></StreamPlayer>
      </div>
    </el-col>
    <!-- end Video Area -->

    <Settings
      v-if="isMounted"
      @hideSettings='toggleSettings'
      :settingsVisible='newRegister ? !settingsVisible : settingsVisible'
    />
    <Workouts
      @hideWorkouts='toggleWorkouts'
      :workoutsVisible='woVisible'
    />

    <DiscoDrawer
      @hideDiscoDrawer='toggleDiscover'
      :discoverVisible='discoVisible'
    />
  </el-row>
</template>

<script>
import RTCClient from "../agora-rtc-client"
import StreamPlayer from "../components/streamPlayer"
import WorkoutSelector from "../components/workoutSelector"
import firebase from "firebase"
import { log } from '../utils/utils'

export default {
  components: {
    StreamPlayer,
    WorkoutSelector,
    Workouts: () => import("../components/workouts"),
    Settings: () => import("../components/settings"),
    DiscoDrawer: () => import("../components/DiscoDrawer"),
    Menu: () => import("../components/menu"),
  },
  props: {
    loggedIn: Boolean,
    newRegister: Boolean
  },
  data () {
    return {
      option: {
        appid: '74fc225b6cfd49aa9d24102ff0d4911a',
        token: '',
        uid: null,
        channel: '',
      },
      isMobile: '',
      channelNameTooltip: false,
      leaveBtnText: 'Leave room',
      joined: false,
      inviteLink: '',
      localStream: null,
      remoteStreams: [],
      woVisible: false,
      settingsVisible: false,
      discoVisible: false,
      isMounted: false,
      roomCreator: '',
      activeUsers: [],
      selectedWorkout: {},
      listenerInt: '',
      isCollapsed: false,
      isTrainer: '',
      isHidden: true,
      scheduleVisible: false,
      startTime: '',
      duration: '',
      price: '',
      shareStatus: 'open',
      scheduledWorkoutTags: [],
      selectScheduledWO: {},
      scheduledWOKey: '',
      woData: [],
      inputTagVisible: false,
      inputTagValue: '',
      username: localStorage.username
    }
  },
  methods: {
    handleTagClose(tag) {
      this.scheduledWorkoutTags.splice(this.scheduledWorkoutTags.indexOf(tag), 1)
    },
    showTagInput() {
      this.inputTagVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleTagInputConfirm() {
      let inputTagValue = this.inputTagValue
      if (inputTagValue) {
        this.scheduledWorkoutTags.push(inputTagValue)
      }
      this.inputTagValue = ''
    },
    clearSchedule() {
      this.scheduleVisible = false
      this.startTime = ''
      this.duration = ''
      this.price = ''
      this.scheduledWorkoutTags = []
      this.selectScheduledWO = {}
      this.shareStatus = 'open'
      this.option.channel = ''
    },
    cancelConfirmSchedule() {
      this.clearSchedule()
    },
    async confirmSchedule() {
      let uid = JSON.parse(localStorage.getItem('user')).uid

      await firebase.database().ref().child(uid).child('workouts').get().then(snapshot => {
        if (snapshot.exists()) {
          if (this.scheduledWOKey != '') {
            let workouts = Object.values(snapshot.val())
            
            // find workout with this key
            this.selectScheduledWO = workouts.find(obj => {
              return obj.value === this.scheduledWOKey[0]
            })
          }
        }
      })
      
      let scheduledWO = {
        key: this.startTime + uid,
        host: localStorage.username,
        uid: uid,
        image: JSON.parse(localStorage.getItem('user')).photoURL,
        name: this.option.channel,
        startTime: this.startTime,
        duration: this.duration,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        price: this.price,
        tags: this.scheduledWorkoutTags,
        workout: this.selectScheduledWO,
        shareStatus: this.shareStatus
      }

      firebase.database().ref('scheduledWO/').push(scheduledWO, error => {
        if (error) {
          console.log(error.message)
        } else {
          this.$message({
            message: 'Successfully scheduled workout!',
            type: 'success'
          })
          this.$nextTick(() => this.clearSchedule())
        }
      })
    },
    toggleHiddenActions() {
      this.isHidden = !this.isHidden
      this.channelNameTooltip = !this.channelNameTooltip
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
    toggleSettings() {
      this.settingsVisible = !this.settingsVisible
    },
    toggleWorkouts() {
      this.woVisible = !this.woVisible
    },
    toggleDiscover() {
      this.discoVisible = !this.discoVisible
    },
    inviteRoom(room) {
      if (window.location.hash) {
        this.inviteLink = window.location.href
      } else {
        this.inviteLink = window.location.href + '#' + room
      }
      alert(this.inviteLink)
    },
    joinRoom() {
      this.option.channel = this.option.channel.toLowerCase()

      let roomExists = null,
          currentRoomCreator = '',
          channel = this.option.channel

      firebase.database().ref('rooms/').once('value').then(snapshot => {
        roomExists = snapshot.child(channel).exists()
        currentRoomCreator = snapshot.child(channel).child('roomCreator').child('username').val()

        if (roomExists != true) {
          // Creating new room to store shared room data
          firebase.database().ref('rooms/' + channel).set({
            'roomName': channel,
            'roomCreator': {
              'username': localStorage.username,
              'isTrainer': this.isTrainer,
              'profilePic': localStorage.photoURL
            }
          }, (error) => {
            if (error) {
              console.log(error.message)
            } else {
              firebase.database().ref('rooms/').once('value').then(snapshot => {
                this.roomCreator = snapshot.child(channel + '/roomCreator').val()
                this.activeUsers = snapshot.child(channel + '/activeUsers').val()
              })
              this.$message({
                message: 'Successfully created room',
                type: 'success'
              })
              this.leaveBtnText = 'Close room'
            }
          })
        } else if (roomExists && currentRoomCreator == localStorage.username) {
          // Entering room you created and never destroyed
          firebase.database().ref('rooms/').once('value').then(snapshot => {
            this.roomCreator = snapshot.child(channel + '/roomCreator').val()
            this.activeUsers = snapshot.child(channel + '/activeUsers').val()
            this.selectedWorkout = snapshot.child(channel + '/selectedWorkout').val()
          })
          this.leaveBtnText = 'Close room'
        } else {
          // Joining room
          let userID = JSON.parse(localStorage.getItem('user')).uid
          firebase.database().ref('rooms/' + channel + '/activeUsers/' + userID).set({
            'username': localStorage.username,
            'profilePic': localStorage.photoURL
          }, (error) => {
            if (error) {
              console.log(error.message)
            } else {
              firebase.database().ref('rooms/').once('value').then(snapshot => {
                this.roomCreator = snapshot.child(channel + '/roomCreator').val()
                this.activeUsers = snapshot.child(channel + '/activeUsers').val()
              })
              this.$message({
                message: 'Successfully joined room',
                type: 'success'
              })
            }
          })
          this.leaveBtnText = 'Leave room'
        }
      })

      // Joining Agora video call
      if (!this.option.appid) {
        this.judge('Appid')
        return
      }
      if (!this.option.channel) {
        this.judge('Channel Name')
        return
      }
      this.rtc.joinChannel(this.option).then(() => {
        this.$message({
          message: 'Successfully joined',
          type: 'success'
        })
        this.rtc.publishStream().then((stream) => {
          this.$message({
            message: 'Successfully published',
            type: 'success'
          })
          this.localStream = stream
        }).catch((err) => {
          this.$message.error('Publish Failure');
          log('publish local error', err)
        })
      }).catch((err) => {
        this.$message.error('Join Failure');
        log('join channel error', err)
      })

      this.joined = true
      window.location.hash = this.option.channel.replaceAll(' ', '-')

      // Initiate db listener
      this.listenerInt = setInterval(() => {
        if (this.joined) {
          firebase.database().ref('rooms/').once('value').then(snapshot => {
            if (snapshot.child(this.option.channel + '/activeUsers').exists() == true) {
              this.activeUsers = snapshot.child(this.option.channel + '/activeUsers').val()
            } else {
              this.activeUsers = false
            }

            if (snapshot.child(this.option.channel + '/selectedWorkout').exists() == true) {
              this.selectedWorkout = snapshot.child(this.option.channel + '/selectedWorkout').val()
            } else {
              this.selectedWorkout = {}
            }

            let roomExists = snapshot.child(this.option.channel.toLowerCase()).exists()
            if ( roomExists == false) {
              this.leaveRoom()
              clearInterval(this.listenerInt)
            }
          })
        }
      }, 2000)
    },
    leaveRoom() {

      if (this.roomCreator.username !== localStorage.username) {
        // Exit room
        let userID = JSON.parse(localStorage.getItem('user')).uid
        firebase.database()
          .ref('rooms/' + this.option.channel + '/activeUsers/' + userID)
          .remove()
          .then(() => console.log('left room'))
          .catch(err => console.log(err.message))
      } else {
        // Destroy room
        firebase.database()
          .ref('rooms/' + this.option.channel.toLowerCase())
          .remove()
          .then(() => console.log('deleted room'))
          .catch(err => console.log(err.message))
      }

      // Leaving Agora video call
      if (this.localStream) {
        this.rtc.leaveChannel().then(() => {
          this.$message({
            message: 'Successfully exited room',
            type: 'success'
          });
        }).catch((err) => {
          this.$message.error('Leave Failure')
          log('leave error', err)
        })
        this.localStream = null
        this.remoteStreams = []
      }

      this.joined = false
      this.option.channel = ''
      this.leaveBtnText = 'Leave room'
      if (window.location.hash) {
        let uri = window.location.toString()
        
        if (uri.indexOf("#") > 0) {
          let clean_uri = uri.substring(0, uri.indexOf("#"))
          window.history.replaceState({}, document.title, clean_uri)
        }
      }
    },
    judge(detail) {
      this.$notify({
        title: 'Notice',
        message: `Please enter the ${detail}`,
        position: 'top-left',
        type: 'warning'
      });
    },
  },
  computed: {
    startDisabled: function() {
      return this.option.channel.length < 3
    },
    confirmScheduleDisabled: function() {
      if (this.startTime == '' ||
      this.price == '' ||
      this.option.channel == '') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    activeUsers: {
      deep: true,
      handler() {console.log('activeUsers watched')}
    }
  },
  mounted() {
    // Check for hash
    const hashChannel = urlHash => {
      this.option.channel = urlHash
      this.joinRoom()
    }
    if (window.location.hash) {
      let hash = window.location.hash.substring(1).replaceAll('-', ' ').toLowerCase()
      hashChannel(hash)
    }

    // Close or Leave room on closing tab
    window.addEventListener('beforeunload', () => {
      if (this.joined) {
        this.leaveRoom()
      }
    })

    this.loggedIn && this.$refs.mainArea.$el.classList.add('in')

    this.$nextTick(function () {
      this.isMounted = true
    })
  },
  beforeMount() {
    let uid = JSON.parse(localStorage.getItem('user')).uid

    // Retrieve Workouts data
    firebase.database().ref().child(uid).child('workouts').get().then((snapshot) => {
      if (snapshot.exists()) {
        this.woData = Object.values(snapshot.val())
      }
    }).catch((error) => {
      console.error(error)
    })
  },
  created() {
    let uid = JSON.parse(localStorage.getItem('user')).uid
    firebase.database().ref().child(uid).child('isTrainer').get().then(snapshot => this.isTrainer = snapshot.val())

    // Document Keypress Listener
    const keyPress = e => {
      if (e.key === "Escape" && this.joined) {
        window.location.href = window.location.href.substr(0, window.location.href.indexOf('#'))
        this.leaveRoom()
      }
    }
    document.addEventListener('keydown', keyPress)

    // ****** isMobile
    // Define our viewportWidth variable
    let viewportWidth
    // Set/update the viewportWidth value
    let setViewportWidth = () => {
      viewportWidth = window.innerWidth || document.documentElement.clientWidth
    }
    // Log the viewport width into the console
    let logWidth = () => {
      if (viewportWidth > 991) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    }
    // Set our initial width and log it
    setViewportWidth()
    logWidth()
    // On resize events, recalculate and log
    window.addEventListener('resize', () => {
      setViewportWidth()
      logWidth()
    }, false)

    this.rtc = new RTCClient()
    let rtc = this.rtc
    rtc.on('stream-added', (evt) => {
      let {stream} = evt
      log("[agora] [stream-added] stream-added", stream.getId())
      rtc.client.subscribe(stream)
    })
      
    rtc.on('stream-subscribed', (evt) => {
      let {stream} = evt
      log("[agora] [stream-subscribed] stream-added", stream.getId())
      if (!this.remoteStreams.find((it) => it.getId() === stream.getId())) {
        this.remoteStreams.push(stream)
      }
    })

    rtc.on('stream-removed', (evt) => {
      let {stream} = evt
      log('[agora] [stream-removed] stream-removed', stream.getId())
      this.remoteStreams = this.remoteStreams.filter((it) => it.getId() !== stream.getId())
    }) 

    rtc.on('peer-online', (evt) => {
      this.$message(`Peer ${evt.uid} is online`)
    }) 

    rtc.on('peer-leave', (evt) => {
      this.$message(`Peer ${evt.uid} already left`)
      this.remoteStreams = this.remoteStreams.filter((it) => it.getId() !== evt.uid)
    }) 
  }
 }
</script>

<style>
.main-area {
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: .5s;
}

.main-area.in {
  opacity: 1;
  visibility: visible;
}

.left-sidebar {
  background-color: #fff;
  box-shadow: 3px 0 5px rgba(0,0,0,.16);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 300px;
  min-width: 300px;
  overflow-x: hidden;
  padding: 16px 0 0;
  transition: .15s;
  width: 300px;
  z-index: 1;
}

.left-sidebar.collapsed {
  max-width: 50px;
  min-width: 50px;
  width: 50px;
}

.left-sidebar--logo {
  margin-bottom: 8px;
  padding: 0 8px;
}

.left-sidebar.collapsed .left-sidebar--logo {
  margin-bottom: 0;
}

.left-sidebar--logo img {
  width: 100%;
}

.left-sidebar--title h1 {
  margin: 0;
}

.left-sidebar--inputs {
  padding: 0 8px;
}

.left-sidebar--inputs .channel-name-tooltip {
  display: block;
}

.left-sidebar--inputs input[type=text] {
  margin-bottom: 16px;
}

.left-sidebar--actions {
  display: flex;
  height: 41px;
  overflow: hidden;
  padding: 0 8px;
  transition: .15s;
}

.left-sidebar--actions .el-popover__reference-wrapper > button {
  width: 100%;
}

.left-sidebar--actions .left-sidebar--action-btns {
  display: inline-block;
  min-height: 40px;
  width: 50%;
}

.left-sidebar--actions .left-sidebar--action-btns + .left-sidebar--action-btns {
  margin-left: 8px;
}

.left-sidebar--actions.invisible-actions {
  height: 0;
}

.left-sidebar--actions.invisible-actions + hr {
  margin-top: 0;
  transition: .15s;
}

.active-users {
  padding: 0 8px;
}

.active-users--creator {
  margin-bottom: 8px;
}

.active-users--list {
  display: flex;
  flex-wrap: wrap;
}

.active-users--list .el-avatar {
  margin-bottom: 8px;
  margin-right: 8px;
}

.active-users--list .el-avatar:nth-child(4n) {
  margin-right: 0;
}

.view {
  animation: gradient 30s ease infinite;
  background: linear-gradient(-45deg, #e020aa, #efa829);
  background-size: 400% 400%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
}

@-webkit-keyframes gradient {
  0%{background-position:0 50%}
  50%{background-position:100% 50%}
  100%{background-position:0 50%}
}
@-moz-keyframes gradient {
  0%{background-position:0 50%}
  50%{background-position:100% 50%}
  100%{background-position:0 50%}
}
@keyframes gradient {
  0%{background-position:0 50%}
  50%{background-position:100% 50%}
  100%{background-position:0 50%}
}

.view .title-area {
  color: #fff;
  padding: 64px;
}

.view .title-area p {
  margin-bottom: 8px;
}

.view .title-area h1 {
  font-size: 40px;
  font-weight: 600;
  margin-top: 0;
}

.view .video {
  max-height: 50%;
}

.view .video.local {
  width: 100%;
}

.view .video.remote {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 25%;
  flex-direction: row;
  flex-grow: 1;
  flex-wrap: wrap;
}

.view .video .agora-video-player {
  display: flex;
  width: 100%;
}

.view .video .agora-video-player div[id*=player] {
  max-width: 100% !important;
  max-height: 100% !important;
}

.view .video .agora-video-player div[id*=player] video[id*=video] {
  object-fit: contain !important;
}

.hide-sidebar {
  margin-top: auto;
}

.hide-sidebar .hide-sidebar--btn {
  border-color: transparent;
  width: 100%;
  overflow: hidden;
}

.hide-sidebar .hide-sidebar--btn span {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.price {
  position: relative;
}

.price:before {
  content: '$';
  font-size: 16px;
  left: 16px;
  pointer-events: none;
  position: absolute;
  top: 21px;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.price.el-input-number.is-controls-right .el-input__inner {
  padding-left: 30px;
}

.el-popper[x-placement^=right] {
  margin-left: 20px !important;
}

.share-status {
  display: flex !important;
  margin: 16px 0;
  width: 100%;
}

.share-status label.el-radio-button {
  width: 100%
}

.share-status label.el-radio-button .el-radio-button__inner {
  width: 100%;
}

.el-tag {
  margin-bottom: 8px;
  margin-left: 8px;
}
.el-button.button-new-tag {
  margin-left: 10px;
}
.el-input.input-new-tag {
  width: 90px;
  margin-left: 8px;
  vertical-align: middle;
}

.el-input.input-new-tag input {
  margin-bottom: 0 !important;
  padding-left: 8px;
  padding-right: 8px;
}

.el-avatar>img {
  width: 100%;
}

/******************************
*
*
* MOBILE STYLES
*
*
******************************/

@media (max-width: 991px) {
  .main-area {
    background-color: #fff;
    flex-direction: column-reverse;
    justify-content: space-between;
  }

  .left-sidebar {
    box-shadow: none;
    height: auto;
    max-width: 100%;
    min-width: 100%;
    overflow: visible;
    padding: 16px 16px;
    position: relative;
    width: 100%;
    z-index: 2;
  }

  .left-sidebar hr {
    display: none;
  }

  .left-sidebar .left-sidebar--actions {
    margin-bottom: 16px;
  }

  .view {
    background: linear-gradient(0deg, #e020aa, #e47ec7);
    background-size: 100% 100%;
    border-radius: 0 0 32px 32px;
    flex-grow: 1;
    overflow: hidden;
    z-index: 1;
  }

  .view .title-area {
    padding: 64px 24px 0;
  }

  .view .title-area h1 {
    font-size: 32px;
  }

  .view .video {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .view .video.local {
    display: flex;
    max-width: 100%;
    max-height: 100%;
  }
}

@media (max-height: 667px) {
  .view .title-area {
    padding: 48px 24px 0;
  }
}

</style>
